import component from './CardMultiImage';

export default component;
